module.exports = __webpack_public_path__ + "static/guide-right-img.1381e894.png";